module.exports = __webpack_public_path__ + "img/fond_open_access.13465b35.jpg";